var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    advertiser,
    rate,
    apr,
    date,
    omtagLearnMore
  } = options;

__p+='\n\n<div class="col-lg-12 col-md-12 col-sm-4">\n  <div class="list-mortgage-item margin-bottom-lg">\n    <h5 class="font-bold no-margin">'+
((__t=( rate ))==null?'':__t)+
' at '+
((__t=( advertiser.Points ))==null?'':__t)+
' pts</h5>\n    <ul class="apr-fees font-size-small list-horizontal list-style-disc">\n      <li>'+
((__t=( apr ))==null?'':__t)+
'% APR</li>\n      <li>$'+
((__t=( advertiser.LoanFees ))==null?'':__t)+
' ('+
((__t=( date ))==null?'':__t)+
')</li>\n    </ul>\n    <h6 class="font-size-small font-semibold no-margin padding-top-sm">'+
((__t=( advertiser.Advertiser ))==null?'':__t)+
'</h6>\n    <ul class="nmls-state font-size-small list-horizontal list-style-disc">\n      ';
 if (advertiser.MlsNumber != '') { 
__p+='<li>NMLS # '+
((__t=( advertiser.MlsNumber ))==null?'':__t)+
'</li>';
 } 
__p+='\n      ';
 if (advertiser.StateLicense != '') { 
__p+='<li>State Lic # '+
((__t=( advertiser.StateLicense ))==null?'':__t)+
'</li>';
 } 
__p+='\n    </ul>\n    <ul class="font-size-small list-horizontal list-style-disc mini-rate-actions">\n      ';
 if (advertiser.PhoneNo != '') { 
__p+='<li>'+
((__t=( advertiser.PhoneNo ))==null?'':__t)+
'</li>';
 } 
__p+='\n      ';
 if (advertiser.CpcUrl != '') { 
__p+='\n      <li><a target="_blank" href="'+
((__t=( advertiser.CpcUrl ))==null?'':__t)+
'" data-omtag="'+
((__t=( omtagLearnMore ))==null?'':__t)+
'">Learn more</a></li>\n      ';
 } 
__p+='\n    </ul>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage_rate_item.jst.ejs